import React from 'react';
import PropTypes from 'prop-types';

const DRAWINGS_CATEGORY = { name: 'Online Entries', value: 'D - Ticket' };
const QUESTS_CATEGORY = { name: 'Quest', value: 'Quest' };
const FOOD_CREDITS_CATEGORY = {
  name: 'Food Credits',
  value: 'F - Food and Beverage'
};

const DiscoverCategoryTiles = ({
  onSelectHotPicks,
  onSelectCategory,
  preferredLocation,
  isDesktop,
  openBookingPage
}) => {
  const RightColumnCategoriesWrapper = ({ children }) =>
    isDesktop ? (
      <>{children}</>
    ) : (
      <div className="category-row-mobile">{children}</div>
    );

  return (
    <div className="discover-categories-container">
      <div className="events-tile">
        <div className="location-title">Wind Creek {preferredLocation}</div>
        <div className="discover-title-large">Hotel Stay</div>
        <button
          className="book-stay-button"
          type="button"
          onClick={openBookingPage}
        >
          Book a Stay
        </button>
      </div>
      <RightColumnCategoriesWrapper>
        <div className="middle-tiles-container">
          <div className="dining-tile">
            <div className="dining-title">Dining. Refined.</div>
            <button
              className="shop-now-button"
              type="button"
              onClick={() => onSelectCategory(FOOD_CREDITS_CATEGORY)}
            >
              Shop now
            </button>
          </div>
          <div className="middle-bottom-tiles-container">
            <div className="quests-tile">
              <div className="quests-title">Quests</div>
              <button
                className="shop-now-button"
                type="button"
                onClick={() => onSelectCategory(QUESTS_CATEGORY)}
              >
                Shop now
              </button>
            </div>
            <div className="hotpicks-tile">
              <div className="hotpicks-title">Hot Picks</div>
              <button
                className="shop-now-button"
                type="button"
                onClick={onSelectHotPicks}
              >
                Shop now
              </button>
            </div>
          </div>
        </div>
        <div className="drawings-tile">
          <div className="drawings-title">Online Entries</div>
          <button
            className="shop-now-button"
            type="button"
            onClick={() => onSelectCategory(DRAWINGS_CATEGORY)}
          >
            Shop now
          </button>
        </div>
      </RightColumnCategoriesWrapper>
    </div>
  );
};

DiscoverCategoryTiles.propTypes = {
  preferredLocation: PropTypes.string,
  openBookingPage: PropTypes.func,
  isDesktop: PropTypes.bool,
  onSelectHotPicks: PropTypes.func,
  onSelectCategory: PropTypes.func
};

export default DiscoverCategoryTiles;
